function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, JSON, Map, Object, String, alertName, alertThreshold, alertType, allProjectMembers, errors, isEditing, projectMembersLoaded, readOnly, recipients, selectedAlertKeys, thresholdFocused) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['custom-alert-condition-operator-and-threshold'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("mp-select", {
          "attrs": {
            options: JSON.stringify(Object.keys($helpers.CUSTOM_ALERT_OPERATOR)),
            'selected-option': $helpers.getSelectedConditionOp(),
            theme: `light`,
          },
          "on": {
            change: $helpers.handleConditionOpChange,
          },
          "class": {
            'custom-alert-condition-op': true
          },
        }));
        __jade_nodes = __jade_nodes.concat(($attr(`enable-condition-types`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`is-editing-mode`)) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-condition-type-text': true
              },
            }, [__vjadeSafeCode(customAlertTypeTexts[alertType])]));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-select", {
              "attrs": {
                'menu-width': `300`,
                options: JSON.stringify(Object.values(customAlertTypeTexts)),
                'selected-option': customAlertTypeTexts[alertType],
                theme: `light`,
              },
              "on": {
                change: $helpers.handleConditionTypeChange,
              },
              "class": {
                'custom-alert-condition-type': true
              },
            }));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-alert-condition-threshold': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("mp-autoresizing-input", {
            "attrs": {
              'max-length': `15`,
              placeholder: thresholdFocused ? `` : `0`,
              'input-style-overrides': JSON.stringify({
                'border': `solid 1px ${!!errors[`alertThreshold`] ? `#E4567B` : `#D8E0EA`}`,
                'border-radius': `4px`,
                'color': `#6d859e`,
                'height': `41px`,
                'min-width': `36px`,
                'padding': `6px`,
                'text-align': `right`,
              }),
            },
            "hook": {
              insert: $helpers.handleThresholdInputInsert,
            },
            "props": {
              type: `string`,
              value: alertThreshold === null ? `` : `${displayThreshold}`,
            },
            "on": {
              blur: $helpers.handleThresholdBlur,
              change: $helpers.handleThresholdChange,
              focus: $helpers.handleThresholdFocus,
            },
            "class": {
              'custom-alert-condition-threshold-percent': $attr(`is-percentage-threshold`) || alertType === $helpers.CUSTOM_ALERT_TYPE.relativePercent
            },
          }));
          __jade_nodes = __jade_nodes.concat((!!errors[`alertThreshold`]) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
              "attrs": {
                'always-show': true,
                placement: `top`,
                type: `error`,
              },
            }, [__vjadeSafeCode(errors[`alertThreshold`])]));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const displayThreshold = alertThreshold && ($attr(`is-percentage-threshold`) ? (alertThreshold * 100).toFixed(2) : alertThreshold);
    const keysAndValues = $attr(`results-keys-and-values`) || [];
    const selectedKeys = selectedAlertKeys || [];
    const customAlertTypeTexts = $helpers.getCustomAlertTypeTexts();
    return {
      value: (h("div", {
        "class": Object.assign({}, {
          'custom-alert-wrapper-readonly': readOnly,
        }, {
          'custom-alert-wrapper': true
        }),
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'custom-alert-title': true
          },
        }, [__vjadeSafeCode($helpers.getModalTitle())])); /*  ------ read only ----- */
        __jade_nodes = __jade_nodes.concat((readOnly) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, [__vjadeSafeCode(alertName)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert me when");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((function() {
                  var $$obj = (selectedKeys);
                  var $$eachNodes;
                  var $$iterated = false;
                  if (Array.isArray($$obj)) {
                    $$eachNodes = $$obj.reduce(function($$eachNodes, key, $index) {
                      $$iterated = true;
                      return $$eachNodes.concat((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'custom-alert-condition-key': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-header': true
                            },
                          }, [__vjadeSafeCode(`${key.displayHeader} :`)]));
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-text': true
                            },
                          }, [__vjadeSafeCode(key.displayValue)]));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this));
                    }, []);
                  } else {
                    $$eachNodes = [];
                    for (var $$objKey in $$obj) {
                      (function() {
                        var $index = $$objKey;
                        if ($$obj.hasOwnProperty($index)) {
                          $$iterated = true;
                          var key = $$obj[$index];
                          $$eachNodes = $$eachNodes.concat((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-key': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-header': true
                                },
                              }, [__vjadeSafeCode(`${key.displayHeader} :`)]));
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-text': true
                                },
                              }, [__vjadeSafeCode(key.displayValue)]));;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this));
                        }
                      })();
                    }
                  }

                  return $$eachNodes;
                })());;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("current value is");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": Object.assign({}, {
                  'custom-alert-condition-threshold-percent': $attr(`is-percentage-threshold`)
                }, {
                  'custom-alert-section-values': true
                }),
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat((((alertType) == ($helpers.CUSTOM_ALERT_TYPE.relativePercent))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + (displayThreshold) + "% " + ($helpers.getSelectedConditionOp()) + " the previous value");;
                    return __jade_nodes
                  }).call(this)) :
                  (((alertType) == ($helpers.CUSTOM_ALERT_TYPE.relativeValue))) ?
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + (displayThreshold) + " " + ($helpers.getSelectedConditionOp()) + " the previous value");;
                    return __jade_nodes
                  }).call(this)) :
                  ((function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat("" + ($helpers.getSelectedConditionOp()) + " " + (displayThreshold) + "");;
                    return __jade_nodes
                  }).call(this)));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("send at most once every");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, [__vjadeSafeCode($helpers.getSelectedFrequency())]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, [__vjadeSafeCode(`recipients (${recipients.length})`)]));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-email-recipients-input", {
                  "key": `alert-recipients-readonly`,
                  "attrs": {
                    borderless: true,
                    disabled: true,
                    recipients: JSON.stringify($helpers.getRecipientAttrs()),
                  },
                  "props": {
                    projectMembersMap: new Map()
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedCancel
              },
              "attrs": {
                size: `small`,
                disabled: false,
              },
              "class": {
                'mp-button-secondary': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Close");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean))); /*  ------ end of read only ----- */ ;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-content': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert name");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("input", {
                  "attrs": {
                    type: `text`,
                    placeholder: alertName === `` ? $helpers.DEFAULT_ALERT_NAME : alertName,
                  },
                  "props": {
                    value: isEditing ? alertName : ``
                  },
                  "on": {
                    input: $helpers.handleAlertNameChange
                  },
                  "class": Object.assign({}, {
                    'custom-alert-invalid-input': !!errors[`alertName`]
                  }, {
                    'custom-alert-name': true
                  }),
                }));
                __jade_nodes = __jade_nodes.concat((!!errors[`alertName`]) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": {
                      'always-show': true,
                      placement: `top`,
                      type: `error`,
                    },
                  }, [__vjadeSafeCode(errors[`alertName`])]));;
                  return __jade_nodes
                }).call(this)) : undefined);;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("alert me when");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(($attr(`is-editing-mode`)) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (selectedKeys);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, key, $index) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-key': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-header': true
                              },
                            }, [__vjadeSafeCode(key.displayHeader)]));
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-text': true
                              },
                            }, [__vjadeSafeCode(key.displayValue || key)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var $index = $$objKey;
                          if ($$obj.hasOwnProperty($index)) {
                            $$iterated = true;
                            var key = $$obj[$index];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-key': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-header': true
                                  },
                                }, [__vjadeSafeCode(key.displayHeader)]));
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-text': true
                                  },
                                }, [__vjadeSafeCode(key.displayValue || key)]));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this)) : ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat((function() {
                    var $$obj = (keysAndValues);
                    var $$eachNodes;
                    var $$iterated = false;
                    if (Array.isArray($$obj)) {
                      $$eachNodes = $$obj.reduce(function($$eachNodes, key, idx) {
                        $$iterated = true;
                        return $$eachNodes.concat((function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'custom-alert-condition-key': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'custom-alert-condition-header': true
                              },
                            }, [__vjadeSafeCode(key.displayName)]));
                            __jade_nodes = __jade_nodes.concat((key.values.length === 1) ? ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-text': true
                                },
                              }, [__vjadeSafeCode(key.displayValues[0])]));
                              __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                "attrs": {
                                  placement: `top`
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat("This segment only has one value");;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this)) : ((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                "attrs": {
                                  'menu-width': 300,
                                  searchable: true,
                                  sections: $helpers.getAlertKeyOptions(key, idx),
                                  theme: `light`,
                                },
                                "on": {
                                  change: ev => $helpers.handleConditionKeyChange(ev, idx)
                                },
                                "class": Object.assign({}, {
                                  'custom-alert-condition-key-error': $helpers.displayKeyConditionErrorByIndex(idx)
                                }, {
                                  'custom-alert-condition-key-dropdown': true
                                }),
                              }));;
                              return __jade_nodes
                            }).call(this)));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this));
                      }, []);
                    } else {
                      $$eachNodes = [];
                      for (var $$objKey in $$obj) {
                        (function() {
                          var idx = $$objKey;
                          if ($$obj.hasOwnProperty(idx)) {
                            $$iterated = true;
                            var key = $$obj[idx];
                            $$eachNodes = $$eachNodes.concat((function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat(h("div", {
                                "class": {
                                  'custom-alert-condition-key': true
                                },
                              }, (function() {
                                var __jade_nodes = [];
                                __jade_nodes = __jade_nodes.concat(h("div", {
                                  "class": {
                                    'custom-alert-condition-header': true
                                  },
                                }, [__vjadeSafeCode(key.displayName)]));
                                __jade_nodes = __jade_nodes.concat((key.values.length === 1) ? ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                    "class": {
                                      'custom-alert-condition-text': true
                                    },
                                  }, [__vjadeSafeCode(key.displayValues[0])]));
                                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                                    "attrs": {
                                      placement: `top`
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    __jade_nodes = __jade_nodes.concat("This segment only has one value");;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this)) : ((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("mp-select", {
                                    "attrs": {
                                      'menu-width': 300,
                                      searchable: true,
                                      sections: $helpers.getAlertKeyOptions(key, idx),
                                      theme: `light`,
                                    },
                                    "on": {
                                      change: ev => $helpers.handleConditionKeyChange(ev, idx)
                                    },
                                    "class": Object.assign({}, {
                                      'custom-alert-condition-key-error': $helpers.displayKeyConditionErrorByIndex(idx)
                                    }, {
                                      'custom-alert-condition-key-dropdown': true
                                    }),
                                  }));;
                                  return __jade_nodes
                                }).call(this)));;
                                return __jade_nodes
                              }).call(this).filter(Boolean)));;
                              return __jade_nodes
                            }).call(this));
                          }
                        })();
                      }
                    }

                    return $$eachNodes;
                  })());;
                  return __jade_nodes
                }).call(this)));
                __jade_nodes = __jade_nodes.concat((!!errors[`alertConditionKeys`]) ? ((function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                    "attrs": {
                      'always-show': true,
                      placement: `top`,
                      type: `error`,
                    },
                  }, [__vjadeSafeCode(errors[`alertConditionKeys`])]));;
                  return __jade_nodes
                }).call(this)) : undefined);
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-alert-condition-is': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("is");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));
                __jade_nodes = __jade_nodes.concat(jade_mixins['custom-alert-condition-operator-and-threshold'].call(this));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("send at most once every");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-values': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-select", {
                  "attrs": {
                    'menu-width': 100,
                    options: JSON.stringify(Object.keys($helpers.CUSTOM_ALERT_FREQUENCY)),
                    'selected-option': $helpers.getSelectedFrequency(),
                    theme: `light`,
                  },
                  "on": {
                    change: $helpers.handleSelectFrequency
                  },
                  "class": {
                    'custom-alert-frequency': true
                  },
                }));;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'custom-alert-section': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'custom-alert-section-title': true
                },
              }, [__vjadeSafeCode(`recipients (${$helpers.getNonEmptyValidRecipientCount()})`)]));
              __jade_nodes = __jade_nodes.concat((projectMembersLoaded) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("div", {
                  "class": {
                    'custom-alert-section-values': true
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat(h("mp-email-recipients-input", {
                    "key": `alert-recipients`,
                    "attrs": {
                      borderless: false,
                      disabled: false,
                      recipients: JSON.stringify($helpers.getRecipientAttrs()),
                    },
                    "props": {
                      projectMembersMap: new Map(allProjectMembers.map(m => [m.email, m]))
                    },
                    "on": {
                      changed: $helpers.handleRecipientsChanged
                    },
                  }));;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);
              __jade_nodes = __jade_nodes.concat((errors[`recipients`]) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat(h("mp-tooltip", {
                  "attrs": {
                    'always-show': true,
                    placement: `top`,
                    type: `error`,
                    'offset': `-30`,
                  },
                }, (function() {
                  var __jade_nodes = [];
                  __jade_nodes = __jade_nodes.concat("Some recipient email addresses are invalid");;
                  return __jade_nodes
                }).call(this).filter(Boolean)));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'custom-alert-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedCancel
              },
              "attrs": {
                theme: `tertiary`,
                size: `small`,
                disabled: false,
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Cancel");;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("mp-button", {
              "on": {
                click: $helpers.clickedSave
              },
              "attrs": {
                size: `small`,
              },
              "class": {
                'mp-button-primary': true,
                'custom-alert-save-button': true
              },
            }, [__vjadeSafeCode(isEditing ? `Save alert` : `Create alert`)]));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Map" in locals ? locals.Map : typeof Map !== "undefined" ? Map : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "alertName" in locals ? locals.alertName : typeof alertName !== "undefined" ? alertName : undefined, "alertThreshold" in locals ? locals.alertThreshold : typeof alertThreshold !== "undefined" ? alertThreshold : undefined, "alertType" in locals ? locals.alertType : typeof alertType !== "undefined" ? alertType : undefined, "allProjectMembers" in locals ? locals.allProjectMembers : typeof allProjectMembers !== "undefined" ? allProjectMembers : undefined, "errors" in locals ? locals.errors : typeof errors !== "undefined" ? errors : undefined, "isEditing" in locals ? locals.isEditing : typeof isEditing !== "undefined" ? isEditing : undefined, "projectMembersLoaded" in locals ? locals.projectMembersLoaded : typeof projectMembersLoaded !== "undefined" ? projectMembersLoaded : undefined, "readOnly" in locals ? locals.readOnly : typeof readOnly !== "undefined" ? readOnly : undefined, "recipients" in locals ? locals.recipients : typeof recipients !== "undefined" ? recipients : undefined, "selectedAlertKeys" in locals ? locals.selectedAlertKeys : typeof selectedAlertKeys !== "undefined" ? selectedAlertKeys : undefined, "thresholdFocused" in locals ? locals.thresholdFocused : typeof thresholdFocused !== "undefined" ? thresholdFocused : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;